import { onScopeDispose, ref } from 'vue'

/**
 * A clock the page can read. It advances once a second while the page is
 * mounted, so a figure measured against it — how long a run has been going,
 * how long it has been waiting for a machine — visibly moves.
 *
 * This is the sign that work is happening (founder, 2026-09-21, notes 17/18/25):
 * the customer never sits in front of a still screen wondering whether anything
 * is running. It is a measured figure, not an animation: the value is real
 * elapsed time, and when nothing is in flight the caller shows nothing.
 */
export function useNow() {
  const now = ref(Date.now())
  if (import.meta.client) {
    const timer = window.setInterval(() => { now.value = Date.now() }, 1000)
    onScopeDispose(() => window.clearInterval(timer))
  }
  return now
}
